// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"f46b6647","179":"ead253c9","221":"7e1604fc","494":"e6e87055","834":"c8bf1cdc","841":"a2afa0eb"}[chunkId] + ".chunk.js";
};